import { useDispatch, useSelector } from 'react-redux'
import { Routes, Route } from 'react-router-dom'
import { useEffect } from 'react'

import Login from './components/Login.js' 
import RecuperacionCuenta from './components/RecuperacionCuenta.js'
import ProtectedRoute from './components/protectedRoutes/ProtectedRoute.js'
import LoginProtectedRoute from './components/protectedRoutes/LoginProtectedRoute.js'
import Error404 from './components/Error404.js'
import DashboardProtectedRoute from './components/protectedRoutes/DashboardProtectedRoute.js'
import Disclaimer from './components/protectedRoutes/Disclaimer.js'
import { getDeviceName } from './app/urlSlice.js'

import Dashboard from './components/Dashboard.js'
import CierreCaja from './components/components-otros/CierreCaja.js'
import Parqueo from './components/parqueo/Parqueo.js'
import Morosidad from './components/components-otros/Morosidad.js'
import AdmisionesIndex from './components/admisiones/AdmisionesIndex.js'
import Facturacion from './components/c&m/Facturacion.js'
import DashboardAlumnos from './components/dashboard-alumnos/DashboardAlumnos.js'

import { CambioConIndex } from './components/cambio-contrasena/CambioConIndex'

import { RoutesComponents } from './RoutesComponents.js'

import VerificaSolvente from './components/protectedRoutes/VerificaSolvente.js'
import ModalSolvente from './components/protectedRoutes/MoodalSolvente.js'

import BusquedaSolicitudIndex from './components/busqueda-solicitud/BusquedaSolicitudIndex.js'

import CentroIndex from './components/centro/CentroIndex.js'
import PerfilAlumnoIndex from './components/perfil-alumno/PerfilAlumnoIndex.jsx'
import EquiposIndex from './components/equipos/EquiposIndex.jsx'
import ContabilidadArchivo from './components/components-contabilidad-archivo/ContabilidadArchivo.jsx'
import DetalleCertificacionFacturas from './components/components-contabilidad-otros/DetalleCertificacionFacturas.js'
import InventarioStockSedeIndex from './components/inventario-stock-sede/InventarioStockSedeIndex.jsx'

const findAccess = (arr, path) => {
  if (Array.isArray(arr)) {
    const acceso = arr.filter(x => x.path === path)[0]?.access
    if (acceso === undefined) {
      const accesoSub = arr.map(xx => {
        let submen
        if (xx.path === '#') {
          submen = xx.submen.filter(xxy => xxy.path === path)[0]?.access
        }
        if (acceso !== undefined) {
          return submen
        }
      })
      return accesoSub
    } else {
      return acceso
    }
  }
  return null
}

const findSolvente = (arr, path) => {
  if (Array.isArray(arr)) {
    return arr.filter(x => x.path === path)[0]?.solvente
  }
}

let arrSub = []

const App = () => {

  const dispatch = useDispatch()

  const dirWebApp = process.env.REACT_APP_DIR_PRO

  const headersApi = useSelector((state) => state.url.headersAPI)

  const { paths: accessArr, pathDefault } = useSelector(state => state.auth)

  if (accessArr !== undefined && accessArr !== null && accessArr !== '') {
    arrSub.splice(0, arrSub.length)
    accessArr.map(x => {
      if (x.path !== '#' && x.name !== 'Dashboard') {
        arrSub.push({ path: x.path, access: x.access, name: x.name, icono: x.icono, component: x.component, pathcomponente: x.pathcomponente, solvente: x.solvente })
      }
      if (x.path === '#') {
        x.submen.map(xx => {
          arrSub.push({ path: xx.path, access: xx.access, name: xx.name, icono: xx.icono, component: xx.component, pathcomponente: xx.pathcomponente })
        });
      }
    });
  }

   const url = process.env.REACT_APP_URL_API // Para pruebas
  //  const url = process.env.REACT_APP_URL_API_PRO // Para producción 

  var configObj = {
    method: 'get',
    url: url + '/utils/device_name',
    headers: headersApi
  }

  // const loggedInValida = useSelector((state) => state.auth.loggedIn)

  // console.log(loggedInValida)

  // if (loggedInValida === null || loggedInValida === undefined || loggedInValida === '' || loggedInValida === false) {
  //   dispatch(getAuth({
  //     config: {
  //       method: "POST", //Propiedad method, "POST", "GET", etc
  //       url: process.env.REACT_APP_URL_API_SEG + "/seguridad/login", //URL de la API
  //       headers: {
  //         'Authorization': process.env.REACT_APP_TOKEN_API,
  //         'Content-ID': process.env.REACT_APP_AUDIENCIA_API,
  //         'Content-Type': 'application/json'
  //       }, //Propiedad headers, por si la API solicita token, audiencia, etc
  //       payload: JSON.stringify({ LoginId: 'publico', password: md5('C@mpu$22') }), //Propiedad payload --> datos a enviar en la solicitud http
  //     },
  //     rememberUser: false,
  //   }))
  // }

  useEffect(() => {
    dispatch(getDeviceName(configObj))
  }, [])

  const loggedIn = useSelector((state) => state.auth.loggedIn)

  // const validarUser = useSelector(state => state.auth.user)

  //console.log(loggedIn)
  // console.log(validarUser)

  const Carnet = useSelector(state => state.auth.Carnet)

  const defaultPaths = {
    Dashboard: <Dashboard />,
    DashboardAlumnos: <DashboardAlumnos />,
    Facturacion: <Facturacion />,
    CierreCaja: <CierreCaja />,
    Parqueo: <Parqueo />,
    Morosidad: <Morosidad />,
    AdmisionesIndex: <AdmisionesIndex />,
  }

  return (
    <>
      <div>
        <Routes>
          <Route path={`${dirWebApp}login`} element={<LoginProtectedRoute user={loggedIn}>
            <Login />
          </LoginProtectedRoute>} />

          <Route path={dirWebApp} element={<DashboardProtectedRoute user={loggedIn} access={findAccess(accessArr, '/')} name='Dashboard'>
            {defaultPaths[pathDefault]}
          </DashboardProtectedRoute>} />

          {accessArr !== undefined && accessArr !== null && accessArr !== '' &&
            arrSub.map(element => {
              return (
                <Route key={element.name} path={`/campus${element.path}`} element={
                  <ProtectedRoute user={loggedIn} access={findAccess(accessArr, `${element.path}`)}>
                    <VerificaSolvente Carnet={Carnet} url={url} headers={headersApi} solvente={findSolvente(accessArr, `${element.path}`)} ruta={element.path}>
                      <RoutesComponents component={element.component} route={element.pathcomponente} />
                    </VerificaSolvente>
                  </ProtectedRoute>
                } />
              )
            })
          }
          <Route path={`${dirWebApp}admisiones`} element={<AdmisionesIndex />} />
          <Route path={`${dirWebApp}busquedasolicitud`} element={<BusquedaSolicitudIndex />} />
          <Route path={`${dirWebApp}admisiones/:idSolicitud/:fechaNacimiento`} element={<AdmisionesIndex />} />
          <Route path={`${dirWebApp}disclaimer`} element={<Disclaimer />} />
          <Route path={`${dirWebApp}warning/:titulo`} element={<ModalSolvente />} />
          <Route path={`${dirWebApp}recuperarCuenta`} element={<RecuperacionCuenta />} />
          <Route path={`${dirWebApp}cambiopassword`} element={<CambioConIndex />} />
          <Route path={`${dirWebApp}centro`} element={<CentroIndex />} />
          
          <Route path={`${dirWebApp}certificacion_facturas`} element={<DetalleCertificacionFacturas />} />
          <Route path={`${dirWebApp}inventario_stock_sede`} element={<InventarioStockSedeIndex />} />
          
          <Route path={`${dirWebApp}subir-archivo`} element={<ContabilidadArchivo />} />

          <Route path='*' element={<Error404 />} />

        </Routes>
      </div >
    </>
  )
}

export default App;